import { useEffect, useState } from "react";

const useCountdown = (tDate) => {
  const [targetDate, setTargetDate] = useState(tDate);
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = countDownDate - new Date().getTime();
      if (remaining < 0) return () => clearInterval(interval);
      setCountDown(remaining);
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  let minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  if (minutes + seconds < 0) {
    minutes = 0;
    seconds = 0;
  }

  return [minutes, seconds, setTargetDate];
};

const getReturnValues = (countDown) => {
  // calculate time left
};

export { useCountdown };
